import { useState } from 'react'

import Icon from '@components/utils/Icon'
import { Popover, PopoverTrigger, PopoverContent } from '@components/atoms/Popover'

import { scopedTranslation } from '@utils/I18n'

import { AssigneeSelect } from './AssigneeSelect'
import useAssignShiftSlotMutation from '../assign_shifts/useAssignShiftSlotMutation'

import type { ShiftSlotWithShift } from '../shifts/types'

const t = scopedTranslation('roster_board')

type EmptySlotChipProps = {
  slot: ShiftSlotWithShift
  onChange: () => void
}

export function EmptySlotChip({ slot, onChange }: EmptySlotChipProps) {
  const [open, setOpen] = useState(false)
  const { assignShiftSlot, isPending } = useAssignShiftSlotMutation()

  const handlePick = (supporter: { id: string }) => {
    if (isPending) return
    assignShiftSlot({
      id: slot.id,
      supporterId: supporter.id,
      onSuccess: () => {
        setOpen(false)
        onChange()
      },
    })
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-haspopup="dialog"
          className="tw:inline-flex tw:cursor-pointer tw:items-center tw:gap-1 tw:rounded-full tw:border tw:border-dashed tw:border-gray-300 tw:bg-white tw:px-2.5 tw:py-1 tw:text-xs tw:font-medium tw:text-gray-500 tw:hover:border-primary-400 tw:hover:text-primary-600 tw:focus:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-primary-400"
        >
          <Icon type="plus" className="tw:h-3 tw:w-3" aria-hidden /> {t('assign')}
        </button>
      </PopoverTrigger>
      <PopoverContent portal align="start" role="dialog" aria-label={t('assign_dialog_aria')} className="tw:w-72">
        <AssigneeSelect onPick={handlePick} />
      </PopoverContent>
    </Popover>
  )
}
